var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"Multi-lingual email templates","show-close-button":true,"submit-text":"Create","close-on-outside-click":true},on:{"submit":function($event){return _vm.$emit('submit', _vm.language)},"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"container"},[_c('form-input-group',{attrs:{"field":{
        type: 'select',
        label: 'Select language',
        name: 'language',
        options: _vm.languageOptions,
      }},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }